<template>


<div class="fixed-top" id="header-fixed">


  <b-navbar toggleable="lg" variant="" type=""  >
    <b-navbar-brand href="#">
      <router-link to="/" class="r-link">
      <table>
        <tbody>
          <tr>
              <td rowspan="5">  <b-img class="logo" src="../assets/apdcl_logo.png" fluid   alt="logo"></b-img></td>
          </tr>
            <tr>
              <td id="title-a" class="title-a text-blue ">অসম শক্তি বিতৰণ কোম্পানী লিমিটেড</td>
            </tr>

            <tr>
              <td id="title-e" class="title-e text-blue">ASSAM POWER DISTRIBUTION COMPANY LIMITED</td>
            </tr>

        </tbody>
      </table>
    </router-link>
  </b-navbar-brand>

  <b-navbar-toggle target="nav-collapse" style="border:none; outline: none;">
      <template>
        <div style="border:solid 1px black;border-radius:3px;font-size: 2rem;">
        <b-icon icon="list"  ></b-icon>
      </div>
      </template>
    </b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav class="nav-bgcolor responsiveNavbar" style="">


      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
          <b-nav-item href="#"><router-link class="r-link" to="/">Home</router-link></b-nav-item>
          <b-nav-item href="#"><router-link class="r-link" to="/ActsAndRules">Acts & Policies</router-link></b-nav-item>
          <!-- <b-nav-item href="#"><router-link class="r-link" to="/Tender">Tender</router-link></b-nav-item> -->

          <b-nav-item-dropdown class="r-link" text="Tender" right>
           <b-dropdown-item href="TenderCurrent"><span class="dropdownItem" >Current Financial Year</span></b-dropdown-item>
           <b-dropdown-item href="TenderPrevious"><span class="dropdownItem" >Previous Financial Year</span></b-dropdown-item>
           <b-dropdown-item href="TenderArchive"><span class="dropdownItem" >Archive</span></b-dropdown-item>
           <!-- <b-dropdown-item href="#"><router-link to="/TenderArchive">Financial Year 2018-2019</router-link></b-dropdown-item> -->
         </b-nav-item-dropdown>

         <!-- <b-nav-item-dropdown class="r-link" text="Newsroom" right>
           <b-dropdown-item href="#"><router-link to="/Newsletter">Newsletter</router-link></b-dropdown-item>
           <b-dropdown-item href="#"><router-link to="/BijuleeNewsBulletin">Bijulee News Bulletin</router-link></b-dropdown-item>
             <b-dropdown-item href="#"><router-link to="/PressRelease">Press Release</router-link></b-dropdown-item>
           <b-dropdown-item><a href="https://www.youtube.com/watch?v=tgSJKMbjFIc&feature=youtu.be" target="_blank">Talk Show about APDCL</a></b-dropdown-item>
           <b-dropdown-item href="#"><router-link to="/Testimonial">Testimonials</router-link></b-dropdown-item>
         </b-nav-item-dropdown> -->

         <b-nav-item-dropdown class="r-link" text="News & Media" right>
           <b-dropdown-item href="Award"><span class="dropdownItem" >Awards and Recognition</span></b-dropdown-item>
           <b-dropdown-item href="Newsletter"><span class="dropdownItem" >Newsletter</span></b-dropdown-item>
           <b-dropdown-item href="BijuleeNewsBulletin"><span class="dropdownItem" >Bijulee News Bulletin</span></b-dropdown-item>
           <b-dropdown-item href="PressRelease"><span class="dropdownItem" >Press Release</span></b-dropdown-item>
           <b-dropdown-item href="https://www.youtube.com/watch?v=tgSJKMbjFIc&feature=youtu.be" target="_blank"><span class="dropdownItem" >Talk Show about APDCL</span></b-dropdown-item>
           <b-dropdown-item href="Testimonial"><span class="dropdownItem" >Testimonials</span></b-dropdown-item>
           <b-dropdown-item href="Workshop"><span class="dropdownItem" >Workshop & Seminar</span></b-dropdown-item>

         </b-nav-item-dropdown>


          <b-nav-item href="#"><router-link class="r-link" to="/Contact">Contact</router-link></b-nav-item>

          <!-- <b-nav-item><div id="login"><b-button v-b-modal.modal-headerFixed size="sm" variant="outline-danger" style="margin-top: -5px;">
            Log In </b-button></div>
          </b-nav-item> -->



      </b-navbar-nav>
    </b-collapse>

  </b-navbar>
  <span class="support text-orange" id="support">
      24x7 Customer Support
      <span class="text-danger"><b-icon icon="headphones" variant="danger" scale="1"></b-icon> 1912</span> or
      <b-icon icon="envelope" variant="danger" scale="1"></b-icon>
      <span class="text-danger"> support@apdcl.org</span>
  </span>

  <span class="language" id="language" >
      <router-link class="r-link customSpan" to="/Assamese">অসমীয়া</router-link>
    </span>


  <!-- <span class="language" id="language" >
    <b-input-group  size="sm" class="mb-2" style="width:130px;">
         <b-input-group-prepend  is-text style="background-color:transparent;height:22px ;font-size:15px">
           <b-icon  icon="search" scale="0.75"></b-icon>
         </b-input-group-prepend>
         <b-form-input  style="border: 1px solid #c7c7c7; background-color:transparent;height:22px ;font-size:12px" type="search" placeholder="Search"></b-form-input>
      </b-input-group>

  </span> -->
  <b-modal
  no-close-on-esc
  no-close-on-backdrop
   class="modal fade"
   id="modal-headerFixed"
   hide-footer
   title="Log In to Your Account"

   >
    <div>
      <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-large
        rounded="sm"
        style="z-index:10000;position:absolute"
        variant="dark"
        id="loader"
      >

      <b-container>
        <b-row>
          <b-col cols=3>
             <span style="color: #0d47a1;">Login as :</span>
          </b-col>
            <b-col cols=4 >
              <input type="radio" name="userRadio" @click="radioClicked('consumer')"  id="consumerRadio" value="consumer" checked > Consumer
            </b-col>
           <!-- <b-col cols=4 >
            <input type="radio"   name="userRadio" @click="radioClicked('admin')" id="adminRadio" value="admin"> Admin
          </b-col> -->
          <p id="selectRadio" hidden>Selected: {{ selected }}</p >
        </b-row>
      </b-container>


    <br>
      <!-- USER LOGIN-->
        <div id="userDivFx" class="showDiv" >
          <form action="http://localhost:8081/website/api/postOtp" method="post">

              <label>Enter Mobile Number  </label>
            <b-input-group class="mb-2" style="width:100%;padding-top:0px;padding-bottom:10px;">
              <b-input-group-prepend is-text>
                <b-icon icon="phone"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="text" id="mobileNoFx"  name="mobNo" autocomplete="off" placeholder="Mobile Number" :disabled="mobileReadonlyFx"></b-form-input>
            </b-input-group>

            <div id="sendOtpBtnFx" v-show="!otpSentFx">
              <b-row>
                <b-col cols="12" offset="">

                    <router-link to="">
                      <b-button block @click="sendOtp()" variant="primary">Send OTP</b-button>
                      </router-link>

                </b-col>
              </b-row>
                </div>



            <div  id="otpDivFx" v-show="otpSentFx">

              <label>Enter OTP  </label>
            <b-input-group class="mb-2" style="width:100%;">

              <b-input-group-prepend is-text>
                <b-icon icon="check2-circle"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="text" id="otpFx"  name="otpNo" autocomplete="off" placeholder="Enter OTP" required></b-form-input>
            </b-input-group>
            <span style="color:red;padding-left:40%" id="otpInvalidFx">{{ otpInvalidMsgFx }}</span>
            <b-row>
              <b-col cols="12" offset="">
                  <b-button block type="button" @click="loginUser()" variant="primary">Log In</b-button>
                  <b-button block  @click="resendOtp()" variant="outline-primary">Resend OTP</b-button>
              </b-col>
            </b-row>
          </div>
          </form>
          <b-row>
            <b-col cols="12" style="text-align:center">
                <span  >Don't have an Account? <br>
                <router-link to="/ConsumerRegistration">Register Now</router-link>
              </span>
            </b-col>
          </b-row>
          </div>

            <!-- ADMIN LOGIN-->
            <div id="adminDiv" style="display:none">
            <b-input-group class="mb-2" style="width:100%;">
              <b-input-group-prepend is-text>
                <b-icon icon="person-fill"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="number" id="userIdAdmin"  autocomplete="off" placeholder="User ID"></b-form-input>
            </b-input-group>
            <br><br>
            <b-input-group class="mb-2" style="width:100%;">
              <b-input-group-prepend is-text>
                <b-icon icon="lock-fill"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="password" id="passwordAdmin" autocomplete="off" placeholder="Password"></b-form-input>
            </b-input-group>
            <br><br>
            <b-row>
              <b-col cols="12" offset="">
                  <router-link to="">
                    <b-button block  id="logInAdminBtn" @click="loginAdmin()" variant="primary">Log In</b-button>
                    </router-link>
              </b-col>
            </b-row>
          </div>
          <br><br>
      </b-overlay>
    </div>
  </b-modal>


  <b-modal
  no-close-on-esc
  no-close-on-backdrop
   class="modal fade"
   id="modal-login"
   hide-footer
   title="Log In to Your Account"

   >
    <div>
      <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-large
        rounded="sm"
        style="z-index:10000;position:absolute"
        variant="dark"
        id="loader"
      >

      <b-container>
        <b-row>
          <b-col cols=3>
             <span style="color: #0d47a1;">Login as :</span>
          </b-col>
            <b-col cols=4 >
              <input type="radio" name="userRadio" @click="radioClicked('consumer')"  id="consumerRadio" value="consumer" checked > Consumer
            </b-col>
           <!-- <b-col cols=4 >
            <input type="radio"   name="userRadio" @click="radioClicked('admin')" id="adminRadio" value="admin"> Admin
          </b-col> -->
          <p id="selectRadio" hidden>Selected: {{ selected }}</p >
        </b-row>
      </b-container>


    <br>
      <!-- USER LOGIN-->
        <div id="userDivFx2" class="showDiv" >
          <form action="http://localhost:8081/website/api/postOtp" method="post">

              <label>Enter Mobile Number  </label>
            <b-input-group class="mb-2" style="width:100%;padding-top:0px;padding-bottom:10px;">
              <b-input-group-prepend is-text>
                <b-icon icon="phone"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="text" id="mobileNo1" name="mobNo" autocomplete="off" v-model = "mobileNo" readonly></b-form-input>
            </b-input-group>

            <div  id="otpDivFx2" class="showDiv">

              <label>Enter OTP  </label>
            <b-input-group class="mb-2" style="width:100%;">

              <b-input-group-prepend is-text>
                <b-icon icon="check2-circle"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="text" id="otp1"  name="otpNo" autocomplete="off" placeholder="Enter OTP" required></b-form-input>
            </b-input-group>
            <span style="color:red;text-align:center" id="otpInvalidFx2">Invalid OTP, Please Enter Correct OTP</span>
            <b-row>
              <b-col cols="12" offset="">
                  <!-- <b-button block  @click="loginUser()" variant="primary">Log In</b-button> -->
                  <b-button block type="submit" variant="primary">Log In</b-button>
                  <b-button block  @click="resendOtp1()" variant="outline-primary">Resend OTP</b-button>
              </b-col>
            </b-row>
          </div>
          </form>
          <b-row>
            <b-col cols="12" style="text-align:center">
                <span  >Don't have an Account? <br>
                <router-link to="/ConsumerRegistration">Register Now</router-link>
              </span>
            </b-col>
          </b-row>
          </div>

      </b-overlay>
    </div>
  </b-modal>
</div>

</template>


<script scoped="true">

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

//var this.$urlCommon = "http://localhost:8081/website";
//const this.$urlCommon = "https://www.apdcl.org/website";
Vue.use(Vuex)

var user = 0;

export default{
  computed:{
   userIdState() {
      return this.user_id.length == 12 ? true : false
      //this.login()
    }
  },
  data() {
      return {
        selected: 'consumer',
        user_id: '',
        show: false,
        mobileNo:"",
        otpSentFx: false,
        mobileReadonlyFx: false,
        otpInvalidMsgFx: ''
      }
    },

  methods:{

    validateConsumer(x)
    {

      var user = document.getElementById(x);

      if(isNaN(user.value)){
        this.$bvToast.toast('Enter Numbers Only!', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        user.value="";
        user.focus();
      }
    },
    sendOtp()
    {

      var mb = document.getElementById("mobileNoFx");
      var mobile = mb.value;

      if(mobile == ""){
        this.$bvToast.toast('Mobile can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }
      else if((mobile.length != 10)){
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }
      var parent=this;
      this.show=true;


      axios.post(this.$urlCommon+"/myBijulee/fetchConsumer?mobile_no="+mobile).then(function(response) {
        parent.show=false;
      if(response.data.message=="success")
      {
        axios.post(parent.$urlCommon+"/api/generateOtp?mobNo="+mobile).then(function(response) {
          console.log(response.data);

          if (response.data.message == "success") {
            parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            parent.mobileReadonlyFx = true;
            parent.otpSentFx = true;
          }
        });
      }
      else {
        {
          parent.$bvToast.toast('Mobile Number not registered ! Kindly Register First ', {
            title: `Error`,
            variant: 'danger',
            solid: true
          });
        }
      }
    });


    },
    resendOtp()
    {
      var parent =this;
      var mobile = document.getElementById("mobileNoFx").value;
      parent.show= true;
      axios.post(this.$urlCommon+"/api/reGenerateOtp?mobNo="+mobile).then(function(response) {
        parent.show= false;
        if (response.data.message == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
        }
      else {
          parent.$bvToast.toast('OTP Could not Sent !', {
            title: `danger`,
            variant: 'danger',
            solid: true
          });
        }
      })
      .catch(function(error) {
        console.log(error);
        parent.show = false;
        parent.$bvToast.toast('Network Error !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
      });
    },
    resendOtp1()
    {
      var parent =this;
      var mobile = document.getElementById("mobileNo1").value;
      parent.show= true;
      axios.post(this.$urlCommon+"/api/reGenerateOtp?mobNo="+mobile).then(function(response) {
        parent.show= false;
        if (response.data.message == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
        }
      else {
          parent.$bvToast.toast('OTP Could not Sent !', {
            title: `Error`,
            variant: 'danger',
            solid: true
          });
        }
      })
      .catch(function(error) {
        console.log(error);
        parent.show = false;
        parent.$bvToast.toast('Network Error !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
      });
    },
    loginUser()
    {
      var parent=this;
      this.show=true;
      var mobile = document.getElementById("mobileNoFx").value;
      var otp = document.getElementById("otpFx").value;

      console.log(mobile+"#######"+otp)
      axios.post(this.$urlCommon+"/api/validateOtp?mobNo="+mobile+"&otpNo="+otp).then(function(response) {
        console.log(response.data);

        if (response.data.message == "VALID") {
          parent.show=false;
          parent.$bvToast.toast('OTP Successfully Verified !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
            localStorage.setItem("mobileNo", mobile);
          parent.$router.push({ path: '/ConsumerDashboard?mobileNo=' + mobile })
          return;
        }
        else {
          parent.show= false;
          parent.otpInvalidMsgFx = "Invalid OTP";
        }
      })
      .catch(function(error) {
        console.log(error);
        parent.show = false;
        parent.$bvToast.toast('Network Error !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
      });

    },
    loginAdmin(){
      var user_id = document.getElementById("userIdAdmin");
      var pw = document.getElementById("passwordAdmin");
      var user = user_id.value;

      if(user == ""){
        this.$bvToast.toast('User Id can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }
      if(pw.value == ""){
        this.$bvToast.toast('Password can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }

      var dataToSend = {
        "user_id": user_id.value,
        "password": pw.value
      }
    //    console.log(dataToSend);

      var parent = this;
      parent.show=true;
          axios.post(this.$urlCommon + "/api/web/login/admin", dataToSend).then(function(response) {
            parent.show=false;
            console.log(response.data)
            var data=response.data;
            localStorage.setItem("userId", data.userId);
            localStorage.setItem("roleSet", data.roles);
            localStorage.setItem("userName", data.userName);
           console.log(data.roles.length)
            if (data.roles.length > 0) {
              parent.$router.push({ path: '/AdminDashboard' })
              return;
            }
            else {
              parent.$bvToast.toast('Invalid Username or Password !', {
                title: `Error`,
                variant: 'danger',
                solid: true
              })
            }

          })
          .catch(function(error) {
            console.log(error);
            parent.show = false;
            parent.$bvToast.toast('Network Error !', {
              title: `Error`,
              variant: 'danger',
              solid: true
            });
          });

    }

  },
  mounted(){

  }
}

</script>

<style lang="scss" scoped="true" >
#header-fixed
{
  transition: 0.6s;
  background-color: #ffff;
  box-shadow: 0 4px 7px 1px #e0e0e0;
}

.title-a
{
  font-size: 1.3rem;
  font-weight: 900;
  margin-top: 0px;
  letter-spacing: 0.5px;

}
.title-e
{
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.5px;

}

table
{
  color:#e4dbdb;
}
td
{
  text-align: left !important;
}
.text-orange
{
  color: #ff5722
}
.text-blue
{
  color: #01579b;
}
.border
{
  border:1px solid;
}
.support
{
  display:none;
}
.language
{
  float: right;
  margin-top: -95px ;
  margin-right: 25px;
  position:relative;
  z-index:1000;
}
.customSpan
{
  background-color: #fff78d;
padding: 4px 10px 4px 10px;
font-weight: 600;
border-radius: 2px;
}

#header,#title-e,#title-a,#tagline-a,#tagline-e,#support,#language
{
  transition: 0.5s;
}

.form-popup {
  display: none;
  position: fixed;
  bottom: 0;
  right: 15px;
  border: 3px solid #f1f1f1;
  z-index: 9;
}
.logo{
    height:75px;
    width:75px;
    margin-right:20px;
}


.hideDiv
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;

    padding: 0rem;
}
.showDiv
{
 visibility: visible;
 opacity: 1;
}
@font-face {
  font-family: Assamese_Font;
  src: url("../assets/Assamese_font/KirtanUni.ttf");
}
div{
    font-family: arial, Assamese_Font;
}
</style>